import { takeLatest, put, call, select } from 'redux-saga/effects';
import { REMOVE_PAYMENT_SAGA } from "../sagaTypes";
import { loaderAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getSalesSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/remove_payment`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerRemovePayment(args) {
    const user = yield select(state => state.user);
    const filterDate = yield select(state => state.filterDate);
    const filterUser = yield select(state => state.filterUser);
    const pagination = yield select(state => state.pagination);
    const filterTypesOptions = yield select(state => state.filterTypesOptions);
    const filterCoachesOptions = yield select(state => state.filterCoachesOptions);
    const filterSubjectOptions = yield select(state => state.filterSubjectOptions);
    const filterPaymentMethodsOptions = yield select(state => state.filterPaymentMethodsOptions);
    const filterAdminsOptions = yield select(state => state.filterAdminsOptions);
    const filterMinSum = yield select(state => state.filterMinSum);
    const filterMaxSum = yield select(state => state.filterMaxSum);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('payment_id', args.data.payment_id);
        formData.append('with_subject', args.data.with_subject);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем список акций
            yield put(getSalesSagaAction({
                page: pagination.current,
                from: filterDate.from,
                to: filterDate.to,
                subscription_type: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
                subscription_coach: JSON.stringify(filterCoachesOptions.filter(el => el.active).map(el => el.id)),
                sales_type: JSON.stringify(filterSubjectOptions.filter(el => el.active).map(el => el.id)),
                payment_methods: JSON.stringify(filterPaymentMethodsOptions.filter(el => el.active).map(el => el.id)),
                admins: JSON.stringify(filterAdminsOptions.filter(el => el.active).map(el => el.id)),
                minSum: filterMinSum,
                maxSum: filterMaxSum,
                sales_user: filterUser.user.id
            }));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherRemovePayment() {
    yield takeLatest(REMOVE_PAYMENT_SAGA, workerRemovePayment);
}